import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ChatterProfileCard } from "@/components/social/ChatterProfileCard";
import { GlobalChatterFeed } from "@/components/social/GlobalChatterFeed";
import { ChatterSidebar } from "@/components/social/ChatterSidebar";
import { ConnectionsCard } from "@/components/social/Connections";

export default function Chatter() {
  const [profile, setProfile] = useState(null);
  const [identities, setIdentities] = useState([]);
  const [labelOpts, setLabelOpts] = useState({ postTypes: [], industries: [] });

  useEffect(() => {
    api.get("/profile/me").then(({ data }) => setProfile(data)).catch(() => setProfile(false));
    api.get("/chatter/identities").then(({ data }) => setIdentities(data || [])).catch(() => setIdentities([]));
    Promise.all([api.get("/chatter/post-types"), api.get("/reference/industries")])
      .then(([pt, ind]) => setLabelOpts({
        postTypes: (pt.data || []).map((t) => ({ value: t.id, label: t.name, color: t.color })),
        industries: (ind.data || []).map((i) => ({ value: i.value, label: i.label })),
      })).catch(() => { /* labels optional */ });
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 pt-4 pb-6 sm:px-6" data-testid="chatter-page">
      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-12 lg:gap-5">
        {/* Left column — desktop only, sticky */}
        <aside className="hidden space-y-5 lg:col-span-3 lg:block lg:sticky lg:top-20 lg:self-start lg:max-h-[calc(100vh-6rem)] lg:overflow-y-auto lg:pb-2">
          <ChatterProfileCard profile={profile} />
          {profile && profile.id && (
            <ConnectionsCard userId={profile.user_id} profileType="personal" profileId={profile.id} targetName={profile.display_name} />
          )}
        </aside>

        {/* Middle column — the feed (renders its own mobile sticky header: profile + controls) */}
        <div className="lg:col-span-6">
          <GlobalChatterFeed profile={profile} identities={identities} labelOpts={labelOpts} />
        </div>

        {/* Right column — desktop only (events/resources/ad hidden on mobile) */}
        <aside className="hidden lg:col-span-3 lg:block">
          <ChatterSidebar />
        </aside>
      </div>

      {/* Mobile only: connections below the feed (events & resources are hidden on mobile) */}
      <div className="mt-4 lg:hidden">
        {profile && profile.id && (
          <ConnectionsCard userId={profile.user_id} profileType="personal" profileId={profile.id} targetName={profile.display_name} />
        )}
      </div>
    </div>
  );
}
